import useConfirmContinue from 'app/hooks/useConfirmContinue';
import { DeleteIconIcon } from 'assets/icons';
import { errorToast, successToast } from 'Components/Notifications';
import { useMemo } from 'react';

export const useConfirmDeleteModal = () => {
  const confirmContinue = useConfirmContinue();
  return useMemo(
    () =>
      (
        resource: string,
        onConfirm: () => Promise<any>,
        suppressMessage?: boolean,
      ) => {
        confirmContinue({
          onConfirm: () =>
            onConfirm()
              .then(() => {
                !suppressMessage &&
                  successToast(`${resource} deleted successfully`);
              })
              .catch(() => {
                !suppressMessage && errorToast(`Couldn't delete ${resource}`);
              }),
          theme: 'danger',
          confirmText: 'Delete',
          title: `Delete Confirmation`,
          showDefaultIcon: false,
          Icon: <DeleteIconIcon />,
          text: (
            <>
              Are you sure you want to delete this {resource}?<br /> This will
              permanently remove it from history.
            </>
          ),
        });
      },
    [],
  );
};
